import { render, staticRenderFns } from "./Adver.vue?vue&type=template&id=8291cb2e&scoped=true"
import script from "./Adver.vue?vue&type=script&lang=js"
export * from "./Adver.vue?vue&type=script&lang=js"
import style0 from "./Adver.vue?vue&type=style&index=0&id=8291cb2e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8291cb2e",
  null
  
)

export default component.exports